"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./style.css");
var _consts = require("../../consts");
var _login = require("../../servers/login");
var _login2 = require("../../consts/login");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var AgreementModal = function AgreementModal(props) {
  var onClose = props.onClose,
    loginMode = props.loginMode;
  // 是否选择
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCheck = _useState2[0],
    setIsCheck = _useState2[1];
  /**
   * 勾选
   * @param e
   */
  var handleChange = function handleChange(e) {
    var target = e.target;
    setIsCheck(target.checked);
  };
  /**
   * 确认事件
   */
  var handleConfirm = function handleConfirm() {
    if (!isCheck) {
      return;
    }
    var isWeGame = loginMode === _login2.LOGIN_TYPE_MAP.MERGE && (0, _login2.getLoginType)();
    (0, _login.getLoginVersion)({
      isWeGame: isWeGame
    }).then(function () {
      onClose(false);
    });
  };
  var handleBack = function handleBack() {
    var isWeGame = loginMode === _login2.LOGIN_TYPE_MAP.MERGE && (0, _login2.getLoginType)();
    (0, _login.loginOut)({
      isWeGame: isWeGame
    }).then(function (res) {
      if (res && res.success) {
        window.location.reload();
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_agreement_modal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'gy_agreement_mask'
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'gy_agreement_content'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'gy_agreement_header'
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: _consts.AGREEMENT_URL,
    target: "_blank"
  }, "\u300A\u5149\u5B87\u7528\u6237\u901A\u884C\u8BC1\u534F\u8BAE\u300B"), "\u548C", /*#__PURE__*/_react.default.createElement("a", {
    href: _consts.AGREEMENT_PRIVACY_URL,
    target: "_blank"
  }, "\u300A\u9690\u79C1\u653F\u7B56\u300B"), "\u5DF2\u7ECF\u53D1\u751F\u53D8\u66F4\uFF0C\u8BF7\u60A8\u91CD\u65B0\u786E\u8BA4\u534F\u8BAE\u6761\u6B3E\uFF0C\u5982\u60A8\u4E0D\u540C\u610F\u8BE5\u534F\u8BAE\uFF0C\u5219\u65E0\u6CD5\u7EE7\u7EED\u63A5\u53D7\u5149\u5B87\u6E38\u620F\u63D0\u4F9B\u7684\u76F8\u5173\u670D\u52A1\u3002"), /*#__PURE__*/_react.default.createElement("div", {
    className: 'gy_agreement_body'
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: 'gy_agreement_check',
    type: "checkbox",
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement("div", null, "\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F\u6700\u65B0\u7684", /*#__PURE__*/_react.default.createElement("a", {
    href: _consts.AGREEMENT_URL,
    target: "_blank"
  }, "\u300A\u5149\u5B87\u7528\u6237\u901A\u884C\u8BC1\u534F\u8BAE\u300B"), "\u548C", /*#__PURE__*/_react.default.createElement("a", {
    href: _consts.AGREEMENT_PRIVACY_URL,
    target: "_blank"
  }, "\u300A\u9690\u79C1\u653F\u7B56\u300B"))), /*#__PURE__*/_react.default.createElement("div", {
    className: 'gy_agreement_footer'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('gy_agreement_confirm', {
      disabled: !isCheck
    }),
    onClick: handleConfirm
  }, "\u786E \u8BA4"), /*#__PURE__*/_react.default.createElement("span", {
    className: 'gy_agreement_back',
    onClick: handleBack
  }, "\u8FD4 \u56DE"))));
};
var _default = AgreementModal;
exports.default = _default;